module.exports = "/_next/static/images/About-Us-Header-84554a40eb9d0948d453c9aaaadfa795.jpg";